import { render, staticRenderFns } from "./DocSign.vue?vue&type=template&id=1dae1a66&scoped=true&"
import script from "./DocSign.vue?vue&type=script&lang=js&"
export * from "./DocSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae1a66",
  null
  
)

export default component.exports